import React from 'react';

import PropTypes from 'prop-types';
import { AutomationSuggestionsContextProvider } from './Context';
import Container from './Container';

const AutomationSuggestionsComponent = ({ tabDataRelationship }) => {
  return (
    <AutomationSuggestionsContextProvider relationship={tabDataRelationship}>
      <Container />
    </AutomationSuggestionsContextProvider>
  );
};

AutomationSuggestionsComponent.propTypes = {
  tabDataRelationship: PropTypes.object.isRequired,
};

export default AutomationSuggestionsComponent;
